import { SEARCH_IMGS_ORDER_BY_OPTIONS } from '@core/constants/SEARCHER';

/**
 * Order by options.
 * @type {Array<{id: string, label: string, value: string}>} ORDER_BY_OPTIONS
 */
export const ORDER_BY_OPTIONS = [
    {
        id: SEARCH_IMGS_ORDER_BY_OPTIONS.NEW,
        label: 'Más recientes',
        value: SEARCH_IMGS_ORDER_BY_OPTIONS.NEW,
    },
    {
        id: SEARCH_IMGS_ORDER_BY_OPTIONS.OLD,
        label: 'Más antiguas',
        value: SEARCH_IMGS_ORDER_BY_OPTIONS.OLD,
    },
    {
        id: SEARCH_IMGS_ORDER_BY_OPTIONS.SIM,
        label: 'Más similares',
        value: SEARCH_IMGS_ORDER_BY_OPTIONS.SIM,
    },
    {
        id: SEARCH_IMGS_ORDER_BY_OPTIONS.CAP,
        label: 'Pie de imagen ascendente',
        value: SEARCH_IMGS_ORDER_BY_OPTIONS.CAP,
    },
];

export const DEFAULT_ORDER_BY_OPTIONS = [
    SEARCH_IMGS_ORDER_BY_OPTIONS.NEW,
    SEARCH_IMGS_ORDER_BY_OPTIONS.OLD,
    SEARCH_IMGS_ORDER_BY_OPTIONS.SIM,
];

/**
 * Order by options attributes.
 * @type {{
 *  ORDER_BY_OPTIONS: string,
 * }} ORDER_BY_OPTIONS_ATTRIBUTES
 */
export const ORDER_BY_OPTIONS_ATTRIBUTES = {
    ORDER_BY_OPTIONS: 'order-by-options',
};

/**
 * Event triggered to update the value of the order by event.
 * @type {string} - The event name.
 */
export const UPDATE_VALUE_ORDER_BY_EVENT = 'update-value-order-by';
